module.exports = __webpack_public_path__ + "img/40.29afa320.jpg";